import {GetterTree, MutationTree, Module, ActionTree} from 'vuex'
import {RootState, GroupeState} from '../types'
import {apiUrl} from '@/config/service'
import axios from 'axios'

type GroupeGetter = GetterTree<GroupeState, RootState>

const state: GroupeState = {
  count: null,
  groupes: null,
  groupe: null
}

export const getters: GroupeGetter = {
  groupesGetter: (state) => state.groupes,
  groupeGetter: (state) => state.groupe
}

export const actions: ActionTree<GroupeState, RootState> = {
  async getGroupesAction({commit, state}, queryParams) {
    const {data} = await axios.get(`${apiUrl}/groupe?sortBy=NOM&orderBy=ASC`, {
      params: {
        ...queryParams
      }
    })
    commit('getGroupesMutation', data)
    return data
  },
  async getGroupeByIdAction({commit}, id) {
    commit('resetGroupeMutation')
    const {data} = await axios.get(`${apiUrl}/groupe/${id}`)
    commit('getGroupeByIdMutation', data)
    return data
  },
  async createGroupeAction({commit}, formParams) {
    const {data} = await axios.post(`${apiUrl}/groupe`, formParams)
    return data
  },
  async updateGroupeAction({commit}, {id, formParams}) {
    const {data} = await axios.put(`${apiUrl}/groupe/${id}`, formParams)
    return data
  },
  async deleteGroupeAction({commit}, id) {
    const {data} = await axios.delete(`${apiUrl}/groupe/${id}`)
    return id
  },
  async syncGroupeProspectAction({commit}, {id, formParams}) {
    const {data} = await axios.post(`${apiUrl}/groupe/${id}/prospect/sync`, formParams)
    return data
  }
}

const mutations: MutationTree<GroupeState> = {
  getGroupesMutation(state, data) {
    state.groupes = data
  },
  getGroupeByIdMutation(state, data) {
    state.groupe = data
  },
  resetGroupeMutation(state) {
    state.groupe = null
  }
}

export const groupe: Module<GroupeState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
